import numeral from "numeral";

// rupiah / indonesia (id)
numeral.register("locale", "id", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "rb",
    million: "jt",
    billion: "m",
    trillion: "t",
  },
  currency: {
    symbol: "Rp. ",
  },
});

numeral.locale("id");

function currency(number) {
  return numeral(number).format("$0,0");
}

export const delimiters = (number) => {
  return numeral(number).format("0,0");
};

export function arrayToCurrencyString(arr) {
  let harga_str = "";
  if (!Array.isArray(arr)) {
    return currency(arr);
  }
  if (arr.length <= 0) {
    harga_str = currency(0);
  } else if (arr.length === 1) {
    harga_str = currency(arr[0]);
  } else if (arr.length > 1) {
    const min = Math.min(...arr);
    const max = Math.max(...arr);
    if (min === max) {
      harga_str = currency(min);
    } else {
      harga_str = `${currency(Math.min(...arr))} - ${currency(
        Math.max(...arr)
      )}`;
    }
  }
  return harga_str;
}

export const levelDiscount = (
  harga_normal,
  level,
  global_komisi,
  product_value
) => {
  const productValue =
    product_value !== undefined &&
    product_value !== "" &&
    !Number.isNaN(product_value) &&
    product_value >= 0
      ? product_value
      : 1;
  return harga_normal * global_komisi?.[level] * productValue;
};

const calculateNewPriceLevel = (
  harga_normal,
  level,
  global_komisi,
  product_value
) => {
  if (level === "reseller") {
    return (
      harga_normal -
      levelDiscount(harga_normal, level, global_komisi, product_value)
    );
  }
  if (level === "agen") {
    return (
      harga_normal -
      levelDiscount(harga_normal, level, global_komisi, product_value)
    );
  }
  if (level === "distributor") {
    return (
      harga_normal -
      levelDiscount(harga_normal, level, global_komisi, product_value)
    );
  }
  if (level === "mentorbisnis") {
    return (
      harga_normal -
      levelDiscount(harga_normal, level, global_komisi, product_value)
    );
  }
};

export function calculatePromo(harga_normal, promo) {
  if (!promo) {
    return harga_normal;
  }

  if (promo.tipe === "%") {
    return harga_normal - harga_normal * (promo.nilai / 100);
  } else {
    return harga_normal - promo.nilai;
  }
}

export function calculatePromoLevel(
  harga_normal,
  promo,
  level,
  global_komisi,
  product_value
) {
  if (!promo) {
    return calculateNewPriceLevel(
      harga_normal,
      level,
      global_komisi,
      product_value
    );
  }

  if (promo.tipe === "%") {
    const harga_normal_baru = harga_normal - harga_normal * (promo.nilai / 100);
    const harga_level_baru = calculateNewPriceLevel(
      harga_normal_baru,
      level,
      global_komisi,
      product_value
    );

    return harga_level_baru;
  } else {
    const harga_normal_baru = harga_normal - promo.nilai;
    const harga_level_baru = calculateNewPriceLevel(
      harga_normal_baru,
      level,
      global_komisi,
      product_value
    );

    return harga_level_baru;
  }
}

export function arrayToCurrencyStringPromo(
  arr,
  promo,
  level,
  global_komisi,
  product_value
) {
  let harga_str = "";

  if (!Array.isArray(arr)) {
    if (level) {
      return currency(
        calculatePromoLevel(arr, promo, level, global_komisi, product_value)
      );
    } else {
      return currency(calculatePromo(arr, promo));
    }
  }

  if (arr.length <= 0) {
    harga_str = currency(0);
  } else if (arr.length === 1) {
    if (level) {
      harga_str = currency(
        calculatePromoLevel(arr[0], promo, level, global_komisi, product_value)
      );
    } else {
      harga_str = currency(calculatePromo(arr[0], promo));
    }
  } else if (arr.length > 1) {
    const min = Math.min(...arr);
    const max = Math.max(...arr);
    if (min === max) {
      if (level) {
        harga_str = currency(
          calculatePromoLevel(min, promo, level, global_komisi, product_value)
        );
      } else {
        harga_str = currency(calculatePromo(min, promo));
      }
    } else {
      if (level) {
        harga_str = `${currency(
          calculatePromoLevel(
            Math.min(...arr),
            promo,
            level,
            global_komisi,
            product_value
          )
        )} - ${currency(
          calculatePromoLevel(
            Math.max(...arr),
            promo,
            level,
            global_komisi,
            product_value
          )
        )}`;
      } else {
        harga_str = `${currency(
          calculatePromo(Math.min(...arr), promo)
        )} - ${currency(calculatePromo(Math.max(...arr), promo))}`;
      }
    }
  }
  return harga_str;
}

export function arrayToCurrencyStringKomisi(
  variants,
  level,
  promo,
  global_komisi,
  product_value
) {
  let harga_str = "";

  if (!Array.isArray(variants)) {
    const harga = calculatePromo(variants, promo);
    return currency(levelDiscount(harga, level, global_komisi, product_value));
  }

  if (variants.length <= 0) {
    harga_str = currency(0);
  } else if (variants.length === 1) {
    const harga = calculatePromo(variants[0]?.harga_normal, promo);
    harga_str = currency(
      levelDiscount(harga, level, global_komisi, product_value)
    );
  } else if (variants.length > 1) {
    const komisiArray = variants.map((variant) => {
      const harga = calculatePromo(variant?.harga_normal, promo);
      return levelDiscount(harga, level, global_komisi, product_value);
    });

    const min = Math.min(...komisiArray);
    const max = Math.max(...komisiArray);
    if (min === max) {
      harga_str = currency(min);
    } else {
      harga_str = `${currency(Math.min(...komisiArray))} - ${currency(
        Math.max(...komisiArray)
      )}`;
    }
  }
  return harga_str;
}

export function calculateHargaLevel(
  harga_normal,
  global_komisi,
  level,
  productValue
) {
  const isHargaLevel =
    harga_normal - harga_normal * (global_komisi?.[level] * productValue);
  return isHargaLevel;
}

export default currency;
